import React, { useState } from 'react';

const KnowBeforeYouGo = ({ tips = [] }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="p-4 max-w-7xl mx-auto bg-white border rounded-lg shadow mt-6">
            <div
                className="flex justify-between items-center cursor-pointer"
                onClick={toggleAccordion}
            >
                <h2 className="text-xl text-custom-blue font-semibold">Know Before You Go</h2>
                <span className={`transform transition-transform ${isOpen ? 'rotate-180' : ''}`}>
                    <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                        ></path>
                    </svg>
                </span>
            </div>

            {isOpen && (
                <div className="mt-4 text-gray-700">
                    <hr className="border-1 mb-4" />
                    <ul className="list-disc text-custom-blue pl-5 space-y-2">
                        {tips.map((tipObj, index) => (
                            <li key={tipObj._id || index}>{tipObj.tip}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default KnowBeforeYouGo;
